export default "__VITE_ASSET__DhzfSdQj__"